<template>
  <div class="site__body">
    <div class="block-space block-space--layout--after-header"></div>
    <div class="block">
      <div class="container container--max--xl">
        <div class="row">
          <account-navigation
            active-page="account-password"
          ></account-navigation>
          <change-password></change-password>
        </div>
      </div>
    </div>
    <div class="block-space block-space--layout--before-footer"></div>
  </div>
</template>

<script>
import AccountNavigation from "../accountnavigation/AccountNavigation";
import ChangePassword from "./ChangePassword";

export default {
  name: "AccountPassword",
  components: {
    "account-navigation": AccountNavigation,
    "change-password": ChangePassword
  },
  created() {
    this.$ga.page({
        page: this.$route.fullPath,
        title: this.$route.name,
    });
  }
};
</script>